import axios from "axios";
import { AUTH_CODES } from "@/shared/constants/authCodes.ts";

const wsApiDataHub = axios.create({
  // baseURL: 'http://192.168.30.254:3000/api',
  baseURL: "https://matcontrol.app.cnadvisers.com.ec/api",
  //baseURL: "http://localhost:3000/api",
  headers: {
    "Content-Type": "application/json",
  },
});
wsApiDataHub.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem(AUTH_CODES.ACCESS_TOKEN)}`;
  return config;
});

export default wsApiDataHub;
